import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IndustryEngagement, IndustryEngagementStatus } from "models/industry-engagement";
import Employee from "models/employee";
import Opportunity from "models/opportunity";

export interface IndustryEngagementSliceState {
    industryEngagements: IndustryEngagement[];
    industryEngagementCount: number;
    employees: Employee[];
    opportunities: Opportunity[];
    statuses: IndustryEngagementStatus[];
}

export const initialState: IndustryEngagementSliceState = {
    industryEngagements: [],
    industryEngagementCount: 0,
    employees: [],
    opportunities: [],
    statuses: []
};

const IndustryEngagementSlice = createSlice({
    name: "industryEngagement-slice",
    initialState,
    reducers: {
        setIndustryEngagements(state, { payload }: PayloadAction<IndustryEngagement[]>) {
            state.industryEngagements = payload;
        },
        setIndustryEngagementCount(state, { payload }: PayloadAction<number>) {
            state.industryEngagementCount = payload;
        },
        setIndustryEngagement(state, { payload }: PayloadAction<{
            industryEngagement: IndustryEngagement;
            index: number;
        }>) {
            state.industryEngagements[payload.index] = payload.industryEngagement;
        },
        setIndustryEngagementSearchFields(state, { payload }: PayloadAction<{
            employees: Employee[];
            opportunities: Opportunity[];
            statuses: IndustryEngagementStatus[];
        }>) {
            state.employees = payload.employees;
            state.opportunities = payload.opportunities;
            state.statuses = payload.statuses;
        },
        deleteIndustryEngagement(state, { payload: industryEngagementId }: PayloadAction<string>) {
            state.industryEngagements = state.industryEngagements.filter(e => e.id !== industryEngagementId);
            state.industryEngagementCount = state.industryEngagementCount - 1;
        },
        addIndustryEngagement(state, { payload }: PayloadAction<IndustryEngagement>) {
            state.industryEngagements = [payload, ...state.industryEngagements];
        }
    },
});

export const {
    setIndustryEngagement,
    setIndustryEngagements,
    setIndustryEngagementCount,
    deleteIndustryEngagement,
    setIndustryEngagementSearchFields,
    addIndustryEngagement
} = IndustryEngagementSlice.actions;

export default IndustryEngagementSlice.reducer;